import React from 'react'

export default function WarningIcon() {
  return (
    <div
      style={{
        backgroundColor: '#FC5D13',
        width: '58px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <svg viewBox="0 0 2000 2000" width="20px" height="20px" style={{ margin: '0 auto' }}>
        <path
          d="M960 790.588c-124.574 0-225.882-101.308-225.882-225.882S835.426 338.824 960 338.824s225.882 101.308 225.882 225.882S1084.574 790.588 960 790.588zm-169.412 677.647V903.53h338.824v564.706H790.588zM960 0C430.645 0 0 430.645 0 960s430.645 960 960 960 960-430.645 960-960S1489.355 0 960 0z"
          fill="#ffffff"
          fillRule="evenodd"
        />
      </svg>
    </div>
  )
}
